import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import clsx from "clsx";
import { GREY } from '../../utils/constants';
import { getAtmosphereReaction } from '../../utils/utils';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 3),
    backgroundColor: '#0B243E',
    display: 'flex', 
    '&:first-child': {
        paddingTop: 30,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10
    },
    '&:last-child': {
        paddingBottom: 30,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10
    }
  },
  layoutMsg: {
    padding: theme.spacing(2, 4),
    backgroundColor: '#1C344C',
    marginBottom: 18,
    marginTop: 10,
    borderRadius: 10,
    color: '#fff',
    textAlign: 'start',
    width: 380,
    position:'relative'
  },
  botMsg: {
      flexDirection: 'row-reverse'
    },
  botColor: {
    backgroundColor: '#2592EA'
  },
  time: {
      color: GREY,
      fontWeight: 550
  },
  timeBot: {
    textAlign: 'right',
  },
  messageBox: {
      width: '100%'
  },
  lightMode: {
    backgroundColor: '#fff'
  },
  msgBotLight: {
    backgroundColor: '#ECEFF5',
    color: '#000'
  },
  reactChat: {
    position: 'absolute',
    bottom: -16,
    right: 8,
    height: 35
  }
}));

export default function MessageListener({theme, data}) {
  const classes = useStyles();
  
  const MessageBox = ({msg, className, time, item, theme}) => (
    <Box>
        <Box classes={{root: clsx(classes.layoutMsg, className && className, (!theme && item.from !== 'user') ? classes.msgBotLight : null)}}>
            <Typography component="p" style={{fontWeight: 550}}>
                {msg}
            </Typography>
            {item.atmosphere && 
                <img className={classes.reactChat} src={getAtmosphereReaction(item.atmosphere.sentiment)} alt="smiley" />
            }
        </Box>
        <Typography 
          component="p" 
          classes={{root: clsx(classes.time, (item.from === 'user') && classes.timeBot)}}
        >
            {time}
        </Typography>
    </Box>
  )

  return (
    <Box height={700} overflow="auto">
        {data && data.messages.map((item, index) => {
            return (
                <Box 
                key={index} 
                classes={
                    {root: (item.from === 'user') 
                      ? clsx(classes.root, !theme ? classes.lightMode : null)
                      : clsx(classes.root, classes.botMsg, !theme ? classes.lightMode : null)
                  }
                }>
                    <MessageBox 
                        item={item}
                        msg={item.text} 
                        className={(item.from === 'user') && classes.botColor} 
                        time={item.date}
                        theme={theme}
                    />
                </Box>
            )
        })}
    </Box>
  );
}
